import {
  
    UPDATE_SUBMISSION,
    CLEAR_SUBMISSION,

} from "constants/ActionTypes";

const INIT_STATE = {
    submission: null,
    isUpdate: false,
    isFullTextEdit:false
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_SUBMISSION: {
            return {
                ...state,
                submission: action.payload.submission,
                isUpdate: action.payload.isUpdate,
                isFullTextEdit:action.payload.isFullTextEdit
            }
        }
        case CLEAR_SUBMISSION: {
            return INIT_STATE;
        }
        default:
            return state;
    }
}
